import type { FunctionComponent } from "react";

export interface ThicknessDisplayProps {
  value: number;
  unit: string;
}

export const ThicknessDisplay: FunctionComponent<ThicknessDisplayProps> = ({
  value,
  unit,
}) => {
  return (
    <>
      <span>{value.toFixed(1)}</span>
      <span>{unit}</span>
    </>
  );
};
